import { makeAutoObservable } from 'mobx';
import { ICredentialsStore } from '../integration-store';
import { IShipmonkCredentialsModel } from '../../../../../models/IntegrationsTypes';
import {IOption} from "../../../../../components/inputs/select-dropdown/select-dropdown";

interface ShipmonkWarehouseOption {
    label: string;
    value: string;
}

class ShipmonkCredentialsStore implements ICredentialsStore {
    private _changes: IShipmonkCredentialsModel = {} as IShipmonkCredentialsModel;
    private readonly warehouseOptions: ShipmonkWarehouseOption[] = [
        { label: 'Florida', value: 'FL1' },
        { label: 'California', value: 'CA1' },
        { label: 'Pensylvania', value: 'PA1' },
        { label: 'Pennsylvania 2', value: 'PA2' },
        { label: 'Mexico', value: 'MX1' },
        { label: 'Nevada', value: 'NV1' },
        { label: 'Nevada 2', value: 'NV2' },
        { label: 'Nevada 3', value: 'NV3' },
        { label: 'Kentucky', value: 'KY1' },
        { label: 'New Jersey', value: 'NJ1' },
        { label: 'Texas', value: 'TX1' },
        { label: 'United Kingdom', value: 'UK1' },
        { label: 'Czechia', value: 'CZ1' },
        { label: 'Toronto', value: 'TO1' },
        { label: 'New York', value: 'NY1' },
        { label: 'Kentucky (Deposco)', value: 'KY7' },
        { label: 'Nevada (Deposco)', value: 'NV7' },
        { label: 'Toronto (Deposco)', value: 'TO7' },
        { label: 'New Jersey (Deposco)', value: 'NJ7' },
        { label: 'Bay Shore (Deposco)', value: 'NY7' },
        { label: 'California (Deposco)', value: 'CA7' },
    ];

    constructor() {
        makeAutoObservable(this, {}, { autoBind: true });
    }
    public get storeId() { return this._changes.store_id; };
    public get apiKey() { return this._changes.api_key; };
    public get warehouse() { return this._changes.warehouse; };
    public set warehouse(value: string) { this._changes.warehouse = value; };
    public get internalName() { return this._changes.internal_name };

    public getWarehouseOptionsList(): IOption[] {
        return this.warehouseOptions.map((warehouse: ShipmonkWarehouseOption) => {
            return {
                label: warehouse.label,
                value: warehouse.value,
            }
        }) ?? [];
    }

    setInternalName(value: string) {
        this._changes.internal_name = value;
    };

    setApiKey(value: string) {
        this._changes.api_key = value;
    };

    setStoreId(value: string) {
        this._changes.store_id = value;
    };

    setWarehouse(value: string) {
        this._changes.warehouse = value;
    };

    /** ICredentialsStore implementation ************/
    public async getCredentials() {
        return { ...this._changes };
    }
}

export default ShipmonkCredentialsStore;
